import React from 'react';
import * as Azure from 'us.helper/azure';

const auth = new Azure.ADAuth();

export const AuthCallback = () => <>Hi</>;
